import { Switch, Typography, Stack } from '@mui/material';
import type { SwitchProps } from '@mui/material';
import React from 'react';

interface ViewToggleProps {
  disabled?: boolean;
  checked?: boolean;
  leftLabel: React.ReactNode;
  rightLabel: React.ReactNode;
  onChange?: (checked: boolean) => void;
  switchStyle?: SwitchProps;
}

function ViewToggle({
  disabled = false,
  checked = false,
  leftLabel,
  rightLabel,
  onChange,
  switchStyle,
}: ViewToggleProps) {
  const handleChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    onChange?.(checked);
  };

  const leftChild =
    typeof leftLabel === 'string' ? (
      <Typography variant="overline">{leftLabel}</Typography>
    ) : (
      leftLabel
    );
  const rightChild =
    typeof rightLabel === 'string' ? (
      <Typography variant="overline">{rightLabel}</Typography>
    ) : (
      rightLabel
    );

  const toggle = (
    <Switch
      disabled={disabled}
      checked={checked}
      onChange={handleChange}
      sx={({ palette }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
          padding: 0.25,
          transitionDuration: '300ms',
          '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: palette.primary.contrastText,
            '& + .MuiSwitch-track': {
              backgroundColor: palette.primary.main,
              opacity: 1,
              border: 0,
            },
            '&.Mui-disabled + .MuiSwitch-track': {
              opacity: 0.5,
            },
          },
        },
        '& .MuiSwitch-thumb': {
          boxSizing: 'border-box',
          width: 22,
          height: 22,
        },
        '& .MuiSwitch-track': {
          borderRadius: 26 / 2,
          backgroundColor: palette.divider,
          opacity: 1,
        },
        ...switchStyle,
      })}
    />
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent={{
        xs: 'center',
        md: 'flex-start',
      }}
      spacing={0.5}
    >
      {leftChild}
      {toggle}
      {rightChild}
    </Stack>
  );
}
export default ViewToggle;
